<template>
  <div class="select2_g right">
    <input type="text" readonly="readonly" :class="{ on: open }" @click="changeOpen" v-model="value.label" />
    <ul v-if="open">
      <li v-for="vo in options" @click="changeOption(vo)" :class="{ on: vo.label == value.label }">{{ vo.label }}</li>
    </ul>
  </div>
</template>
<script>
export default {
  name: 'sd-select',
  props: ['options', 'open', 'value'],
  methods: {
    changeOpen() {
      this.$emit('changeOpen');
    },
    changeOption(data) {
      this.$emit('changeOption', data);
    }
  }
};
</script>



// WEBPACK FOOTER //
// sdSelect.vue?0a6dfbd5